// src/data/albums.js
const albums = [
    {
      title: "Pink Moon",
      artist: "Nick Drake",
      img: "/albums/pink-moon-nick-drake.jpg",
      reaction: "7",
      year: 1972,
      link: "https://www.youtube.com/watch?v=jvLtyyBRITo&list=PLc7zUm38GAmHphxz6vRZQB71jzoaUiHAk&index=2" //
    },
    {
      title: "Different Class",
      artist: "Pulp",
      img: "/albums/different-class-pulp.jpg",
      reaction: "Basically no skips on any of these songs. Popular for a reason.",
      year: 1995,
      link: "https://www.youtube.com/watch?v=L1Xcm_ppQz8&list=PLMNMmvIC2uGbYmKfmw-ebMTs8JKgvyvbZ&index=8" //
    },
    {
      title: "Titanic Rising",
      artist: "Weyes Blood",
      img: "/albums/titanic-rising-weyes-blood.jpg",
      reaction: "Reminds me of my final year in Edinburgh - walking around and appreciating the beauty of the city went perfectly with this soft and fluctuating album.",
      year: 2019,
      link: "https://www.youtube.com/watch?v=Ay6_iBJV9cc&list=PLI6kLIhBBwmRuVkqHGa37BJOTFcnYSvJJ&index=3" //
    },
    {
      title: "We Don’t Trust You",
      artist: "Future",
      img: "/albums/we-dont-trust-you-future.jpg",
      reaction: "Best gym music - can only ever get you pumped up.",
      year: 2024,
      link: "https://www.youtube.com/watch?v=53jx17KvusI&list=PLxA687tYuMWjfDkm2yIOeyY6H8n_v2Ppw&index=10" //
    },
    {
    title: "69 Love Songs",
    artist: "The Magnetic Fiels",
    img: "/albums/69-love-songs-the-magnetic-fields.jpg",
    reaction: "I have NOT listened to all of these (who has), but some simple, beautiful songs.",
    year: 2024,
    link: "https://www.youtube.com/watch?v=1uQFlNa1Dk0" //
    },
    {
    title: "April",
    artist: "Jakob",
    img: "/albums/april-jakob.jpg",
    reaction: "Atari Acid is an incredbly underrated song: touches on themes of responsibility and ageing in such a beautiful way.",
    year: 2024,
    link: "https://www.youtube.com/watch?v=AVexBkzsNGg" //
    },
    {
    title: "Coming From Reality",
    artist: "Rodriguez",
    img: "/albums/coming-from-reality-rodriguez.jpg",
    reaction: "Romantic.",
    year: 2024,
    link: "https://www.youtube.com/watch?v=cAjfKWQ8PP0&list=OLAK5uy_kK918g6bKZtdJ9_QQ8ZVBtpZ2zpX6Bx-g&index=3" //
    }, 
    {
    title: "Hardhouse Bible",
    artist: "Various Artists",
    img: "/albums/hardhouse-bible-various-artists.jpg",
    reaction: "My old boss when I worked at a chippy said that hard house was the soundtrack to his 20's. I listened to 'Hooked - Tony De Vit Remix' walking down Mt Kinabalu and I teared up.",
    year: 2024,
    link: "https://www.youtube.com/results?search_query=hooked+tony+de+vit" //
    }, 
    {
    title: "7th Birthday Bassline Mega Mix",
    artist: "Off Me Nut",
    img: "/albums/omn-7th-birthday-megamix.jpg",
    reaction: "The best mix ever produced. Only gets better with every listen (I'm probably on 100~). If Off Me Nut were from London, they'd have won a BRIT.",
    year: 2024,
    link: "https://www.youtube.com/watch?v=rYZ9QMrKOCs&t=2346s" //
    }, 
    {
    title: "The New Abnormal",
    artist: "The Strokes",
    img: "/albums/the-new-abnormal-strokes.jpg",
    reaction: "Heading-pumping and sometimes poignant - this album got me into the Strokes. How many artists have come back after so long and made such good music?",
    year: 2024,
    link: "https://www.youtube.com/watch?v=1-W6whvn8Bs&list=PLlLGTTlLJXAX-UwWbyH8m6SGSWRntdCf0&index=2" //
    }, 
    {
    title: "Little World",
    artist: "Zack Villere",
    img: "/albums/little-world-zack-villere.jpg",
    reaction: "This song reminds of COVID lockdown walks, the age I was and how much older I had gotten.",
    year: 2024,
    link: "https://www.youtube.com/watch?v=2Dt10CZpAu0&list=PLKsbLKf7CgPtcASnpmYzxkt7ApuYFTDYF&index=9" //
    }, 
    {
    title: "All Mirrors",
    artist: "Angel Olsen",
    img: "/albums/angel-olsen-all-mirrors.jpg",
    reaction: "walking through the streets of Edinburgh",
    year: 2020,
    link: "https://www.youtube.com/watch?v=zY4x1MDWWi8&list=PLVrGhShhL2gmrmkf1hi5nqbAWfmN-rHOc&index=11" //
    },
    {
     title: "Black Metal",
     artist: "Dean Blunt", 
     img: "/albums/dean-blunt-black-metal.jpg",
     reaction: "but everybody says I'm wrong",
     year: 2014,
     link: "https://www.youtube.com/watch?v=71440F93Etw&list=PL7ghKCRa1bE-vSAFEvUWQATNlp1D546rv&index=4" //

    },
    {
     title: "Depression Cherry",
     artist: "Beach House", 
     img: "/albums/depression-cherry-beach-house.jpg",
     reaction: "It won't last forever ... or maybe it will",
     year: 2015,
     link: "https://www.youtube.com/watch?v=NFhJRTdmviA&list=PLbOGt8cOph4UNFsqheclqn_76TUMUjpmm&index=6" //
    },
    {
    title: "Soul Mining",
    artist: "The The",
    img: "/albums/soul-mining-the-the.jpg",
    reaction: "",
    year: 1983,
    link: "https://www.youtube.com/watch?v=7ZYgKCbFbWY&list=PLfGibfZATlGrw5NqvPwid9MnpglSuZCzH&index=2"//
    },
    {
    title: "More Life",
    artist: "Drake",
    img: "/albums/more-life-drake.jpg",
    reaction: "Summer 2017",
    year: 2017,
    link: "https://www.youtube.com/watch?v=CzmiPn1BJms&list=PLbUIPZJL6vw-7ef4PuuPJhaK3K-0UxRKO&index=5"//
    },
    {
      title: "Sunshine on Leith",
      artist: "The Proclaimers",
      img: "/albums/sunshine-on-leith-the-proclaimers.jpg",
      reaction: "Edinburgh 20-24 - secretly very beautiful album",
      year: 1988,
      link: "https://www.youtube.com/watch?v=sZ43B71vK0g&list=PLNPGM2D7aODevPpr-WByWhWc-qjoRSd-T&index=6" //
    },
    {
    title: "Blonde",
    artist: "Frank Ocean",
    img: "/albums/blonde-frank-ocean.jpg",
    reaction: "",
    year: 2016,
    link: "https://www.youtube.com/watch?v=r4l9bFqgMaQ&list=PLzoqV_VvWIwGzYTcm3r1JwqgQOBXTvKyd&index=9" //
    },
    {
      title: "A Carnival of Fears",
      artist: "Yellow House",
      img: "/albums/a-carnival-of-fears-yellow-house.jpg",
      reaction: "",
      year: 2017,
      link: "https://www.youtube.com/watch?v=qK9Afg-aks4&list=PLsBewTkIwdI1hp2jCTz_0DQ9KPRSwsbcv" //
    },
    {
      title: "Fresh Air",
      artist: "HOMESHAKE",
      img: "/albums/fresh-air-homeshake.jpg",
      reaction: "every single thing",
      year: 2017,
      link: "https://www.youtube.com/watch?v=0aOzT11GMKM&list=PLZqsyBiYZFQ0tH7RCNRm6DrKRa9DrCU-f&index=4"//
    },
    {
      title: "Atlanta Millionaire's Club",
      artist: "Faye Webster",
      img: "/albums/atlanta-millionaires-club-faye-webster.jpg",
      reaction: "the day that I met you",
      year: 2019,
      link: "https://www.youtube.com/watch?v=TTReFZIAnpU&list=PL-YMUXzPXsLDXBai9Q9cOXc75DYdJmFyk&index=6"//
    },
    {
      title: "A LA SALA",
      artist: "Khruangbin",
      img: "/albums/a-la-sala-khruangbin.jpg",
      reaction: "",
      year: 2024,
      link: "https://www.youtube.com/watch?v=upo8_2NdmRI&list=PL6-B652C0OuIuh2rf9BClnE3WP6fRou3w&index=2"//
    },
    {
      title: "Cry",
      artist: "Cigarettes After Sex",
      img: "/albums/cigarettes-after-sex-cry.jpg",
      reaction: "",
      year: 2024,
      link: "https://www.youtube.com/watch?v=3XqqkrJENB4"//
    },
    {
      title: "From Elvis Presley, Boulevard, Memphis, Tennessee",
      artist: "Elvis Presley",
      img: "/albums/boulevard-memphis-tennesee-elvis-presley.jpg",
      reaction: "",
      year: 2024,
      link: "https://www.youtube.com/watch?v=wvh2t8RIsTo&list=PLtgiPVWmOlIZLXfpnhqJwhw3Hm5-HLF2B&index=3"//
    },
    {
      title: "Grade Pending",
      artist: "Whatever, Dad",
      img: "/albums/grade-pending-whatever-dad.jpg",
      reaction: "",
      year: 2024,
      link: "https://www.youtube.com/watch?v=MqiEeDxYYzg&list=PLW3oi1-1jo-gXBLOfcUdkKm3ouubzIeXg&index=7"//
    },
    {
      title: "Jassbusters",
      artist: "Connan Mockasin",
      img: "/albums/jassbusters-connan-mockasin.jpg",
      reaction: "",
      year: 2024,
      link: "https://www.youtube.com/watch?v=j7WlPeSi-qI"//
    },
    {
      title: "B-Sides and Rarities",
      artist: "Beach House",
      img: "/albums/bsides-and-rarities-beach-house.jpg",
      reaction: "",
      year: 2024,
      link: "https://www.youtube.com/watch?v=8NU-EIgUK3Y&list=PLbOGt8cOph4XuUKFWycP1el4zKv9LV7dM"//
    }
  ];
  
  export default albums;
  

  